// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2rDIi","content":"LoadingAlert_content__3lrX_"};